export default __webpack_public_path__ + "static/media/Savant's Leggings of the Celestial Hilt.03915000.jpg";